var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import * as React from 'react';
import { FormattedMessage } from 'react-intl';
import classNames from 'classnames';
import { EditorState, Modifier } from 'draft-js';

import DatalistItem from '../../datalist-item';
import DraftJSEditor from '../../draft-js-editor';
import SelectorDropdown from '../../selector-dropdown';

import messages from './messages';

import './MentionSelector.scss';

var DefaultSelectorRow = function DefaultSelectorRow(_ref) {
    var _ref$item = _ref.item,
        item = _ref$item === undefined ? {} : _ref$item,
        rest = _objectWithoutProperties(_ref, ['item']);

    return React.createElement(
        DatalistItem,
        rest,
        item.name,
        ' ',
        React.createElement(
            'span',
            { className: 'dropdown-secondary-text' },
            item.email
        )
    );
};

DefaultSelectorRow.propTypes = {
    item: PropTypes.shape({
        name: PropTypes.string,
        email: PropTypes.string
    })
};
var DefaultStartMentionMessage = function DefaultStartMentionMessage() {
    return React.createElement(FormattedMessage, messages.startMention);
};

var MentionStartState = function MentionStartState(_ref2) {
    var message = _ref2.message;
    return React.createElement(
        'div',
        { className: 'mention-start-state' },
        message
    );
};

// babel-plugin-flow-react-proptypes doesn't understand imported types
MentionStartState.propTypes = {
    message: PropTypes.node
};

var DraftJSMentionSelector = function (_React$Component) {
    _inherits(DraftJSMentionSelector, _React$Component);

    function DraftJSMentionSelector(props) {
        _classCallCheck(this, DraftJSMentionSelector);

        var _this = _possibleConstructorReturn(this, (DraftJSMentionSelector.__proto__ || Object.getPrototypeOf(DraftJSMentionSelector)).call(this, props));

        _this.handleMention = function () {
            var onMention = _this.props.onMention;
            var activeMention = _this.state.activeMention;


            if (onMention) {
                onMention(activeMention ? activeMention.mentionString : '');
            }
        };

        _this.handleContactSelected = function (index) {
            var contacts = _this.props.contacts;

            _this.addMention(contacts[index]);
            _this.setState({
                activeMention: null,
                isFocused: true
            }, function () {
                _this.handleMention();
            });
        };

        _this.handleBlur = function (event) {
            var onBlur = _this.props.onBlur;


            _this.setState({
                isFocused: false
            });

            if (onBlur) {
                onBlur(event);
            }
        };

        _this.handleFocus = function (event) {
            var onFocus = _this.props.onFocus;


            _this.setState({
                isFocused: true
            });

            if (onFocus) {
                onFocus(event);
            }
        };

        _this.handleChange = function (nextEditorState) {
            var onChange = _this.props.onChange;


            var activeMention = _this.getActiveMentionForEditorState(nextEditorState);

            _this.setState({
                activeMention: activeMention
            }, function () {
                if (onChange) {
                    onChange(nextEditorState);
                }

                if (activeMention && activeMention.mentionString) {
                    _this.handleMention();
                }
            });
        };

        _this.shouldDisplayMentionLookup = function () {
            var contacts = _this.props.contacts;
            var activeMention = _this.state.activeMention;


            return !!(activeMention && activeMention.mentionString && contacts.length);
        };

        var mentionTriggers = props.mentionTriggers.reduce(function (prev, current) {
            return prev + '\\' + current;
        }, '');

        _this.state = {
            activeMention: null,
            isFocused: false,
            mentionPattern: new RegExp('([' + mentionTriggers + '])([^' + mentionTriggers + ']*)$')
        };
        return _this;
    }

    /**
     * Lifecycle method that gets called when a component is receiving new props
     * @param {object} nextProps Props the component is receiving
     * @returns {void}
     */


    _createClass(DraftJSMentionSelector, [{
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps, nextState) {
            var newContacts = nextProps.contacts;
            var currentContacts = this.props.contacts;
            var activeMention = nextState.activeMention;


            if (activeMention !== null && !newContacts.length && newContacts !== currentContacts && newContacts.length !== currentContacts.length) {
                // if empty set of contacts get passed in, set active mention to null
                this.setState({
                    activeMention: null
                });
            }
        }

        /**
         * Extracts the active mention from the editor state
         *
         * @param {EditorState} editorState
         * @returns {object}
         */

    }, {
        key: 'getActiveMentionForEditorState',
        value: function getActiveMentionForEditorState(editorState) {
            var mentionPattern = this.state.mentionPattern;


            var contentState = editorState.getCurrentContent();
            var selectionState = editorState.getSelection();

            var startKey = selectionState.getStartKey();
            var activeBlock = contentState.getBlockForKey(startKey);

            var cursorPosition = selectionState.getStartOffset();

            var result = null;

            // Break the active block into entity ranges.
            activeBlock.findEntityRanges(function (character) {
                return character.getEntity() === null;
            }, function (start, end) {
                // Find the active range (is the cursor inside this range?)
                if (start <= cursorPosition && cursorPosition <= end) {
                    // Determine if the active range contains a mention.
                    var activeRangeText = activeBlock.getText().substr(start, cursorPosition - start);
                    var mentionMatch = activeRangeText.match(mentionPattern);

                    if (mentionMatch) {
                        result = {
                            blockID: startKey,
                            mentionString: mentionMatch[2],
                            mentionTrigger: mentionMatch[1],
                            start: start + mentionMatch.index,
                            end: cursorPosition
                        };
                    }
                }

                return null;
            });

            return result;
        }

        /**
         * Called on each keypress when a mention is being composed
         * @returns {void}
         */


        /**
         * Method that gets called when a mention contact is selected
         * @param {number} index The selected index
         * @returns {void}
         */


        /**
         * Event handler called when DraftJSEditor emits onChange
         * Checks current text to see if any mentions were made
         * @param {EditorState} editorState The new editor state
         * @returns {void}
         */

    }, {
        key: 'addMention',


        /**
         * Inserts a selected mention into the editor
         * @param {object} mention The selected mention to insert
         */
        value: function addMention(mention) {
            var _this2 = this;

            var activeMention = this.state.activeMention;
            var editorState = this.props.editorState;

            var _ref3 = activeMention || {},
                start = _ref3.start,
                end = _ref3.end;

            var id = mention.id,
                name = mention.name;


            var contentState = editorState.getCurrentContent();
            var selectionState = editorState.getSelection();

            var preInsertionSelectionState = selectionState.merge({
                anchorOffset: start,
                focusOffset: end
            });

            var textToInsert = '@' + name;

            var contentStateWithEntity = contentState.createEntity('MENTION', 'IMMUTABLE', { id: id });

            var entityKey = contentStateWithEntity.getLastCreatedEntityKey();

            var contentStateWithLink = Modifier.replaceText(contentState, preInsertionSelectionState, textToInsert, null, entityKey);

            var spaceOffset = preInsertionSelectionState.getStartOffset() + textToInsert.length;
            var selectionStateForAddingSpace = preInsertionSelectionState.merge({
                anchorOffset: spaceOffset,
                focusOffset: spaceOffset
            });

            var contentStateWithLinkAndExtraSpace = Modifier.insertText(contentStateWithLink, selectionStateForAddingSpace, ' ');

            var editorStateWithLink = EditorState.push(editorState, contentStateWithLinkAndExtraSpace, 'change-block-type');

            this.setState({
                activeMention: null
            }, function () {
                _this2.handleChange(editorStateWithLink);
            });
        }

        /**
         * @returns {boolean}
         */

    }, {
        key: 'render',
        value: function render() {
            var _props = this.props,
                className = _props.className,
                contacts = _props.contacts,
                editorState = _props.editorState,
                error = _props.error,
                hideLabel = _props.hideLabel,
                isDisabled = _props.isDisabled,
                isRequired = _props.isRequired,
                label = _props.label,
                onReturn = _props.onReturn,
                placeholder = _props.placeholder,
                selectorRow = _props.selectorRow,
                startMentionMessage = _props.startMentionMessage,
                onMention = _props.onMention;
            var _state = this.state,
                activeMention = _state.activeMention,
                isFocused = _state.isFocused;


            var classes = classNames('mention-selector-wrapper', className);

            var showMentionStartState = !!(onMention && activeMention && !activeMention.mentionString && isFocused);

            return React.createElement(
                'div',
                { className: classes },
                React.createElement(
                    SelectorDropdown,
                    {
                        onSelect: this.handleContactSelected,
                        selector: React.createElement(DraftJSEditor, {
                            editorState: editorState,
                            error: error,
                            hideLabel: hideLabel,
                            isDisabled: isDisabled,
                            isFocused: isFocused,
                            isRequired: isRequired,
                            label: label,
                            onBlur: this.handleBlur,
                            onFocus: this.handleFocus,
                            onChange: this.handleChange,
                            onReturn: onReturn,
                            placeholder: placeholder
                        })
                    },
                    this.shouldDisplayMentionLookup() ? contacts.map(function (contact) {
                        return React.cloneElement(selectorRow, _extends({}, selectorRow.props, contact, {
                            key: contact.id
                        }));
                    }) : []
                ),
                showMentionStartState ? React.createElement(MentionStartState, { message: startMentionMessage }) : null
            );
        }
    }]);

    return DraftJSMentionSelector;
}(React.Component);

DraftJSMentionSelector.defaultProps = {
    className: '',
    contacts: [],
    isDisabled: false,
    isRequired: false,
    mentionTriggers: ['@', '＠', '﹫'],
    selectorRow: React.createElement(DefaultSelectorRow, null),
    startMentionMessage: React.createElement(DefaultStartMentionMessage, null)
};
DraftJSMentionSelector.propTypes = {
    className: PropTypes.string,
    contacts: PropTypes.arrayOf(PropTypes.shape({
        id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
        name: PropTypes.string.isRequired
    })).isRequired,
    editorState: function editorState() {
        return (typeof EditorState === 'function' ? PropTypes.instanceOf(EditorState).isRequired : PropTypes.any.isRequired).apply(this, arguments);
    },
    error: PropTypes.object,
    hideLabel: PropTypes.bool,
    isDisabled: PropTypes.bool,
    isRequired: PropTypes.bool,
    label: PropTypes.node.isRequired,
    mentionTriggers: PropTypes.arrayOf(PropTypes.string).isRequired,
    onBlur: PropTypes.func,
    onChange: PropTypes.func,
    onFocus: PropTypes.func,
    onMention: PropTypes.func,
    onReturn: PropTypes.func,
    placeholder: PropTypes.string,
    selectorRow: PropTypes.node.isRequired,
    startMentionMessage: PropTypes.node
};


export default DraftJSMentionSelector;
import PropTypes from 'prop-types';